var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-chart"},[_c('md-card-header',{class:[
    { animated: true },
    ( _obj = {}, _obj[_vm.getClass(_vm.backgroundColor)] = true, _obj ),
    { 'md-card-header-text': _vm.HeaderText },
    { 'md-card-header-icon': _vm.HeaderIcon }
  ],attrs:{"data-header-animation":_vm.headerAnimation}},[(_vm.chartInsideHeader)?_c('div',{staticClass:"chart-js-chart"}):_vm._e(),_vm._t("chartInsideHeader")],2),_c('md-card-content',[(_vm.chartInsideContent)?_c('div',{staticClass:"chart-js-chart"}):_vm._e(),_vm._t("content")],2),(!_vm.noFooter)?_c('md-card-actions',{attrs:{"md-alignment":"left"}},[_vm._t("footer")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }